<template>
  <modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
  >
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="addurl"
      >
        <div class="form-group row align-items-center">
          <label for="inputs_name" class="col-sm-3 mb-0">
            {{ $t("name") }}
          </label>
          <app-input
            id="inputs_name"
            class="col-sm-9"
            type="text"
            v-model="inputs.name"
            :required="true"
          />
        </div>
        <div class="form-group row align-items-center">
          <label for="inputs_color_code" class="col-sm-3 mb-0">
            {{ $t("color_code") }}
          </label>
          <input id="inputs_color_code"
            class="col-sm-9"
            type="color"
            v-model="inputs.color_code">
          <!-- <app-input
            id="inputs_color_code"
            class="col-sm-9"
            type="color"
            v-model="inputs.color_code"
            :required="true"
          /> -->
        </div>
        <div class="form-group row align-items-center" v-if="userList.role == 'App Admin'">
          <label for="inputs_email" class="col-sm-3 mb-0">
            {{ $t("for_portal_board") }}
          </label>
          <app-input
            class="mt-2 pt-1 col-sm-9"
            type="radio"
            :list="typeradio"
            v-model="inputs.type"
            :required="true"
          />
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../Mixins/ModalMixin";
import * as actions from "../../../../Config/ApiUrl";
import {CERTIFICATE_CATEGORY_GET} from "../../../../../app/Config/ApiUrl";
import { axiosGet, axiosPost } from "../../../../../app/Helpers/AxiosHelper";

export default {
  name: "AddModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
  },
  data() {
    return {
      addurl:actions.STAGES_STORE,
      preloader: false,
      inputs: {
        type: 0,
      },
      typeradio: [
        { id: "1", value: "Yes" },
        { id: "0", value: "No" },
      ],
      
      categorylist: [],
      modalId: "demo-add-edit-Modal",
      modalTitle: this.$t("add"),
    };
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t("edit");
      // this.preloader = true;
    }
  },
  methods: {
    submit() {
      if (this.modalTitle == "Edit") {

        axiosPost(actions.STAGE_UPDATE, this.inputs)
          .then((res) => {
            
            this.afterSuccess(res);
          })
          .catch((error) => {
            
            this.$toastr.e(error.data.type);
          })
          .finally(() => {
            this.preloader = false;
            this.closeModal();
          });
      }
      else {
        this.save(this.inputs);
      }
      
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      // if (response.data.phone) this.phone = response.data.phone;
      this.inputs = response.data;
      this.inputs.type = response.data.type != null ? '1' : '0';
      this.preloader = false;
    },

    getCategories() {
      axiosGet(CERTIFICATE_CATEGORY_GET)
        .then((res) => {
          this.categorylist = res.data;
        })
        .catch((error) => { 
          
        });
    },
  },

  mounted() {
    $(function () {
      $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
    });
    this.getCategories();
  },
  computed: {
    userList() {
      return this.$store.state.user.loggedInUser;
    },
  },
};
</script>
